export default __webpack_public_path__ + "static/media/XOpen.c96ceea2.jpg";